import { CharterColor } from '../models/charter-color.model';

/** Mode par défaut — identique à Constant.MODE côté mobile. */
export const CHARTER_DEFAULT_MODE = 'light';

export const THEME_MODE_STORAGE_KEY = 'THEME_MODE';

export type ThemeMode = 'light' | 'dark';

const STORAGE_KEY = 'charter_color_cache';

/** Valeurs light Saarvie test (api-design) — utilisées si l'API est indisponible. */
export const CHARTER_COLOR_FALLBACK: CharterColor = {
  id: 'fallback-light',
  mode: 'light',
  principal: '#1F6D45',
  secondary: '#ffb731',
  primaryBg: '#fbf7f7',
  secondaryBg: '#4ddbe8',
  primaryText: '#100101',
  secondaryText: '#FFB731',
  disableText: '#666663',
  lightText: '#ffffff',
  success: '#17af07',
  warning: '#e0cf1a',
  error: '#be1157',
  info: '#11be33',
  exception: '#f4d44e',
  primaryCardBg: '#FFFFFF',
  secondaryCardBg: '#4a4848',
};

/** Valeurs dark Saarvie test (api-design). */
export const CHARTER_COLOR_FALLBACK_DARK: CharterColor = {
  id: 'fallback-dark',
  mode: 'dark',
  principal: '#1F6D45',
  secondary: '#ffb731',
  primaryBg: '#2b2727',
  secondaryBg: '#6a4b4b',
  primaryText: '#ffffff',
  secondaryText: '#FFB731',
  disableText: '#7a6f6f',
  lightText: '#ffffff',
  success: '#17af07',
  warning: '#d1e03f',
  error: '#b14848',
  info: '#523b3b',
  exception: '#541818',
  primaryCardBg: '#4f4b4b',
  secondaryCardBg: '#f7f5f5',
};

export function readThemeMode(): ThemeMode {
  try {
    return localStorage.getItem(THEME_MODE_STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return CHARTER_DEFAULT_MODE;
  }
}

export function writeThemeMode(mode: ThemeMode): void {
  try {
    localStorage.setItem(THEME_MODE_STORAGE_KEY, mode);
  } catch {
    // ignore
  }
}

export function readCharterColorCache(): CharterColor | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as CharterColor;
  } catch {
    return null;
  }
}

export function writeCharterColorCache(color: CharterColor): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(color));
  } catch {
    // ignore quota / private mode
  }
}
